var React = require('react');

function SDCPrint18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"6","y":"12.25","width":"6","height":"1.5","rx":"0.5","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M17.5,4H15V1.5a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5V4H.5a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,.5.5H3v2.5a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5V14h2.5a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,17.5,4ZM4.5,2.5h9V3.97626h-9Zm9,13h-9v-5h9Zm3-3H15v-3a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v3H1.5v-7h15Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCPrint18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCPrint18N;

SDCPrint18N.default = SDCPrint18N;
